/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Period_EndInputs */

const en_settings_billing_period_end = /** @type {(inputs: Settings_Billing_Period_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Period end`)
};

/**
* | output |
* | --- |
* | "Period end" |
*
* @param {Settings_Billing_Period_EndInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_period_end = /** @type {((inputs?: Settings_Billing_Period_EndInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Period_EndInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_period_end(inputs)
});
export { settings_billing_period_end as "settings.billing.period_end" }